/**
 * =============================================================================
 * A/B TEST CONFIGURATION
 * =============================================================================
 * Test: cart-trust-messaging (ABC test)
 * Status: CONCLUDED (2026-04-12) — Variant B won
 *   B — "Risk-free purchase" banner (14-day returns, Device/Cable/Chain)
 *   B content is now hardcoded directly in sections/cart.liquid
 *
 * Previous test: first-shop-only — CONCLUDED (2025-02-12, Variant B won)
 * =============================================================================
 */
const AB_TEST_ENABLED = false;
const AB_TEST_NAME = "cart-trust-messaging";
const WINNING_VARIANT = "B";

/**
 * A/B Test Handler for Shopify Store
 *
 * Handles variant assignment, URL query parameter processing, and analytics events.
 * Loaded with `defer` — runs after DOM is parsed, before DOMContentLoaded fires.
 *
 * Sends events directly to GA4 via gtag() — no GTM tags needed for these events.
 * Events use -shop suffix to distinguish from neosapien.xyz events in GA4.
 *
 * TO REACTIVATE: set AB_TEST_ENABLED = true above and uncomment the active block
 * inside initABTest(). Also restore the JS conditional in sections/cart.liquid.
 */

(function () {
  const AB_TEST_KEY = "neo_ab_test_variant";
  const GA4_MEASUREMENT_ID = "G-T23JDSBLB6";

  /**
   * Check if debug mode is enabled
   */
  function isDebugMode() {
    return (
      window.location.hostname === "localhost" ||
      new URLSearchParams(window.location.search).get("debug_mode") === "true"
    );
  }

  /**
   * Send event directly to GA4 via gtag
   * @param {string} eventName
   * @param {Object} params
   */
  function sendEvent(eventName, params) {
    if (isDebugMode()) {
      params.debug_mode = true;
    }
    params.send_to = GA4_MEASUREMENT_ID;
    gtag("event", eventName, params);
  }

  /**
   * Get query parameter from URL
   * @param {string} name - Parameter name
   * @return {string|null} Parameter value or null
   */
  function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  /**
   * Remove query parameter from URL without page reload
   * @param {string} param - Parameter name to remove
   */
  function removeQueryParam(param) {
    const url = new URL(window.location.href);
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      window.history.replaceState({}, document.title, url.toString());
    }
  }

  /**
   * Initialize A/B test variant handling.
   * Test concluded 2026-04-12 — Variant B won.
   * Assignment logic and GA events preserved below as comments for future reactivation.
   */
  function initABTest() {
    // Test concluded 2026-04-12 — Variant B won.
    // Variant B content is hardcoded in cart.liquid and neo-hero/neo-key-features snippets.
    // All active lines commented out — function is inert. Preserved for reactivation.
    // localStorage.setItem(AB_TEST_KEY, WINNING_VARIANT);
    // document.cookie = "neo_ab_variant=" + WINNING_VARIANT + "; path=/; max-age=7776000; SameSite=Lax";
    // window.neoABTestVariant = WINNING_VARIANT;
    // window.neoABTestEnabled = false;
    // return WINNING_VARIANT;

    /*
    // =========================================================================
    // REACTIVATION BLOCK
    // Uncomment this entire block and set AB_TEST_ENABLED = true to run a new test.
    // Update variant letters, split ratios, and GA event names as needed.
    // Also restore the JS conditional in sections/cart.liquid.
    // =========================================================================
    window.neoABTestEnabled = true;

    const variantFromUrl = getQueryParam("variant");
    const existingVariant = localStorage.getItem(AB_TEST_KEY);
    let finalVariant;
    let eventToFire = null;

    // Case 1: URL carries a variant param (user arrived from neosapien.xyz)
    if (variantFromUrl === "A" || variantFromUrl === "B" || variantFromUrl === "C") {
      finalVariant = variantFromUrl;
      if (existingVariant && existingVariant !== variantFromUrl) {
        eventToFire = "overwritten";
      }
      localStorage.setItem(AB_TEST_KEY, finalVariant);
      document.cookie = "neo_ab_variant=" + finalVariant + "; path=/; max-age=7776000; SameSite=Lax";
      removeQueryParam("variant");
    }
    // Case 2: No URL variant — use existing stored variant
    else if (existingVariant) {
      finalVariant = existingVariant;
    }
    // Case 3: No variant anywhere — user landed directly on shop; assign randomly
    else {
      const rand = Math.random();
      finalVariant = rand < 0.333 ? "A" : rand < 0.667 ? "B" : "C";
      localStorage.setItem(AB_TEST_KEY, finalVariant);
      document.cookie = "neo_ab_variant=" + finalVariant + "; path=/; max-age=7776000; SameSite=Lax";
      eventToFire = "assigned";
    }

    // GA4 events — -shop suffix keeps these separate from neosapien.xyz events
    if (eventToFire === "assigned") {
      sendEvent("ab_test_variant_assigned_shop", {
        variant: finalVariant,
        timestamp: new Date().toISOString(),
      });
    } else if (eventToFire === "overwritten") {
      sendEvent("ab_test_variant_overwritten_shop", {
        variant: finalVariant,
        previous_variant: existingVariant,
        timestamp: new Date().toISOString(),
      });
    }

    window.neoABTestVariant = finalVariant;
    return finalVariant;
    // =========================================================================
    // END REACTIVATION BLOCK
    // =========================================================================
    */
  }

  /**
   * Track landing source independently of AB test state.
   * Reads ?src from URL, persists in sessionStorage, cleans up URL.
   * Runs whether AB testing is enabled or disabled.
   */
  function initLandingSource() {
    const srcFromUrl = getQueryParam("src");
    if (srcFromUrl) {
      sessionStorage.setItem("neo_landing_source", srcFromUrl);
      removeQueryParam("src");
    }
  }

  // window.neoABTestVariant = initABTest();
  initLandingSource();
})();
